/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/home': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.491 1.368a.8.8 0 00-.982 0l-9 7A.8.8 0 002.2 9v11A2.8 2.8 0 005 22.8H19a2.8 2.8 0 002.8-2.8V9a.8.8 0 00-.309-.632l-9-7zm3.31 19.832H19a1.2 1.2 0 001.2-1.2V9.391L12 3.013 3.8 9.391V20A1.2 1.2 0 005 21.2h3.2V12a.8.8 0 01.8-.8h6a.8.8 0 01.8.8v9.2zm-6 0h4.4v-8.4H9.8v8.4z" _fill="currentColor"/>'
  }
})
